var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormalLN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "25px",
    viewBox: "0 0 33 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "normal_l_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings_word",
    transform: "translate(-763.000000, -493.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.5,493 L794.5,493 C795.328427,493 796,493.671573 796,494.5 C796,495.328427 795.328427,496 794.5,496 L764.5,496 C763.671573,496 763,495.328427 763,494.5 C763,493.671573 763.671573,493 764.5,493 Z M764.5,504 L787.24,504 C788.068427,504 788.74,504.671573 788.74,505.5 C788.74,506.328427 788.068427,507 787.24,507 L764.5,507 C763.671573,507 763,506.328427 763,505.5 C763,504.671573 763.671573,504 764.5,504 Z M764.5,515 L791.2,515 C792.028427,515 792.7,515.671573 792.7,516.5 C792.7,517.328427 792.028427,518 791.2,518 L764.5,518 C763.671573,518 763,517.328427 763,516.5 C763,515.671573 763.671573,515 764.5,515 Z",
    id: "normal_l_n"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalLN);
export default __webpack_public_path__ + "static/media/normal_l_n.be3e4719a206bcf144d9a80658c312a0.svg";
export { ForwardRef as ReactComponent };